import {Component, EventEmitter, inject, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgTemplateOutlet} from "@angular/common";
import {IconComponent} from "../icon/icon.component";
import {MobileService} from "../../services/mobile.service";

export interface DropDownItem {
  label: string | number;
  value: unknown | string | number;
}

@Component({
    selector: 'app-dropdown',
    imports: [
    IconComponent,
    NgTemplateOutlet
],
    templateUrl: './dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dropdown.component.scss'
})
export class DropdownComponent {
  readonly mobileService = inject(MobileService);

  @Input() items: DropDownItem[] = [];
  @Input() icon: string = '';
  @Input() ariaLabel: string = '';
  @Input() showIcon: boolean = true;
  @Input() modal: boolean = false;
  @Input() selected: unknown | string | number = null;
  @Output() selectedChange: EventEmitter<unknown | string | number> = new EventEmitter<unknown | string | number>();

  public active: boolean = false;

  public getSelectedItem(): DropDownItem {
    return this.items.find((item: DropDownItem) => JSON.stringify(item.value) === JSON.stringify(this.selected)) ?? {
      label: '',
      value: '',
    };
  }

  public select(item: DropDownItem) {
    this.selectedChange.emit(item.value);
  }

  public toggle(): void {
    this.active = !this.active;
    if (this.active) {
      const listener: () => void = () => {
        this.close();
        document.removeEventListener('click', listener);
      }

      setTimeout(() => {
        document.addEventListener('click', listener);
      });
    }
  }

  public close(): void {
    this.active = false;
  }
}
